<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="ack">ACKNOWLEDGMENTS</a></h2><a id="ack">
<p class="noindent">It would be impossible to finish a project as absorbing and time-consuming as writing a book without the understanding, enthusiasm, and willing tastebuds of my husband and two very sweet daughters. Thanks, too, to Sandi Burke, Heather Tynch, and Cambi Martin for their invaluable assistance and good humor. Thanks to Denise Gee for helping me unravel the mysteries of whiskey and to Nancie McDermott for her advice on cracking coconuts, her memory of the Poky Little Puppy, and her hilarious e-mails when the going got tough. Thanks to my parents for giving me free rein in the kitchen growing up, and to Vicki Villarreal and Nancy Bowen, who were the first to actually hire me and pay me to cook. Finally, many thanks to Bill LeBlond and Amy Treadwell, for their support and encouragement in making this sticky, chewy book a reality; to Carrie Bradley for her gentle editing, and to Ayako Akazawa, Leigh Beisch, Dan Becker, and Sara Slavin for making everything look so beautiful.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02_ack.vue?9cf035ae